<script>
import PreloaderItem from '../PreloaderItem/PreloaderItem.vue';

export default {
    components: {
        PreloaderItem
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        error: {
            type: Boolean,
            default: false
        },
        accepted: {
            type: Boolean,
            default: false,
        }
    },
    methods: {
        previewContract() {
            this.toggled = true;
            this.$emit('previewContractDraft');
        }
    },
}
</script>

<template>
    <div v-if="!accepted" class="contract-draft-preview">
        <div class="contract-draft-preview__button"
             @click="previewContract">
            <span v-if="!loading && !error">{{ $t('contract.draft.preview') }}</span>
            <span v-else-if="!error">
                <preloader-item class="contract-draft-preview__pre-loader"/>
            </span>
            <span v-else>{{ $t('contract.draft.error') }}</span>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractDraftPreview/ContractDraftPreview.vue